import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class PaymentService {

  constructor(private http: HttpCommonService) {
  }

  //获取当前用户信息
  getUserInfo(userType, userId) {
    if (userType == 'person') {//个人
      return this.http.get("/user/center/xhsRest/getPerUser", {userId: userId});
    } else {//企业
      return this.http.get("/user/center/xhsRest/getCorpAuthenInfo", {userId: userId});
    }
  }

  //先生成订单支付编号
  genOrderTradeNo(orderNo: any) {
    return this.http.get('/user/center/xhsRest/pay/genOrderTradeNo', {orderNo: orderNo});
  }

  getOrder(orderNo, orderType, userType?): Observable<any> {
    return this.http.get('/user/center/xhsRest/getOrder',
      {orderNo: orderNo, orderType: orderType, userType: userType});
  }

  getOrderByNo(orderNo): Observable<any> {
    return this.http.get('/user/center/xhsRest/getOrderByNo', {orderNo: orderNo});
  }

  aliPay(order: any, orderName: string): Observable<any> {
    return this.http.post('/user/center/xhsRest/pay/aliPay', {
        orderNo: order.ORDER_NO,
        productName: orderName,
        fee: order.PRICE,
        phoneNo: order.PHONE
      }
    );
  }

  aliPayQuery(orderNo: string): Observable<any> {
    return this.http.get('/user/center/xhsRest/pay/aliPayQuery', {orderNo: orderNo});
  }

  weiXinPay(order: any, orderName: string): Observable<any> {
    return this.http.post('/user/center/xhsRest/pay/weixinPay', {
        orderNo: order.ORDER_NO,
        productName: orderName,
        fee: order.PRICE,
        phoneNo: order.PHONE
      }
    );
  }

  weiXinPayQuery(orderNo: string): Observable<any> {
    return this.http.get('/user/center/xhsRest/pay/weixinPayQuery', {orderNo: orderNo});
  }

  genBasicReport(orderNo: string): Observable<any> {
    return this.http.post('/enterprise/detail/xhsRest/report/genBasicReportByQi', {orderNo: orderNo});
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/payment.service.ts